import React from 'react';

const SearchBar = ({ value, onChange, placeholder }) => {
  return (
    <input
      type="text"
      placeholder={placeholder}
      className="form-control mb-1"
      value={value}
      onChange={onChange}
    />
  );
};

export default SearchBar;
